<template>
  <div>
    <p>Automatically identify and treat phrases in the data as unified terms. Phrases are sequences of two connected terms in the data.</p>
    <p class="example">
      For example, <i>customer service</i> or <i>interest rates</i>.
    </p>
  </div>
</template>